import { Route, Routes } from 'react-router';
import Layout from './components/Layout';
import CommandesList from './pages/CommandesList';
import CommandeNew from './pages/CommandeNew';
import CommandeDetail from './pages/CommandeDetail';
import Horloge from './pages/Horloge';
import Erreurs from './pages/Erreurs';
import Journal from './pages/Journal';
import Referentiel from './pages/Referentiel';
import Scenarios from './pages/Scenarios';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<CommandesList />} />
        <Route path="commandes/new" element={<CommandeNew />} />
        <Route path="commandes/:guid" element={<CommandeDetail />} />
        <Route path="horloge" element={<Horloge />} />
        <Route path="erreurs" element={<Erreurs />} />
        <Route path="journal" element={<Journal />} />
        <Route path="referentiel" element={<Referentiel />} />
        <Route path="scenarios" element={<Scenarios />} />
        <Route path="*" element={<p className="text-sm text-outline">Page introuvable.</p>} />
      </Route>
    </Routes>
  );
}
